var path = 'layout/Footer/index.html';
var html = "<div id=\"footer\">\r\n    <span>Powered by:</span>\r\n    <img src=\"/res/volante_icon.png\"/>\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;